import { jsx as _jsx } from "react/jsx-runtime";
const PreferencesGroup = ({ children }) => (_jsx("div", { className: "mb-3 flex max-w-full flex-col rounded border border-solid border-border bg-default p-6", children: children }));
export default PreferencesGroup;
